module.exports = __webpack_public_path__ + "img/icon-advert.a465f5e2.svg";